import Vue from "vue";
import Element from "element-ui";
import langPtBr from "element-ui/lib/locale/lang/pt-br";
import langEs from "element-ui/lib/locale/lang/es";
import locale from "element-ui/lib/locale";
import "@/plugins/element/theme/element-variables.scss";

if (navigator.language.includes("es")) {
  locale.use(langEs);
} else {
  locale.use(langPtBr);
}

Vue.use(Element, { locale });
